document.querySelectorAll('.projects__rotate-icon').forEach(card => {
  card.addEventListener('click', e => {
    // console.log(e.target.closest('.projects__card'))

    e.target.closest('.projects__card').classList.toggle('flip')
  })
})
